import React from 'react';
import { PageMeta } from '../../components/PageMeta';
import { ResetPassword } from '../../components/ResetPassword';
import './ResetPasswordPage.scss';

export const ResetPasswordPage: React.FC = () => (
  <>
    <PageMeta title="Reset Password" />
    <div className="ResetPasswordPage">
      <ResetPassword />
    </div>
  </>
);
